import {
  App, Flex, Spin,
} from 'antd';
import { getCustomerById } from 'api/customers';
import withGuard from 'components/withGuard';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { captureException } from 'utils/errors';
import Layout from 'components/Layout';
import ContactOverview from './ContactOverview';

function CustomerDetail() {
  const [customer, setCustomer] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();
  const { message } = App.useApp();

  useEffect(() => {
    const getCustomerData = () => {
      setCustomer(null);
      getCustomerById(id)
        .then((data) => {
          setCustomer(data.data);
        })
        .catch((e) => {
          captureException(e);
          message.error('Contact not found');
          navigate('/console/contacts');
        });
    };
    getCustomerData();
  }, [id]);

  if (!customer) {
    return (
      <Flex justify="center" align="center" className="h-[50vh]">
        <Spin size="large" />
      </Flex>
    );
  }
  return (
    <Layout header={(
      <Layout.Header
        backTitle="Contacts"
        // backPath="/console/contacts"
      />
    )}
    >
      <ContactOverview
        customer={customer}
        contact={{
          ...customer,
          first_name: customer.name,
        }}
      />
    </Layout>
  );
}

export default withGuard(CustomerDetail, null, { redirect: true });
